import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
interface MetricsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: number; // Percentage change
  icon?: React.ReactNode;
  color?: 'ginger' | 'charcoal' | 'blue' | 'green';
  delay?: number;
}
export function MetricsCard({
  title,
  value,
  subtitle,
  trend,
  icon,
  color = 'charcoal',
  delay = 0
}: MetricsCardProps) {
  const getColorClass = () => {
    switch (color) {
      case 'ginger':
        return 'text-ginger bg-ginger/10 border-ginger/20';
      case 'blue':
        return 'text-blue-600 bg-blue-50 border-blue-200';
      case 'green':
        return 'text-green-600 bg-green-50 border-green-200';
      default:
        return 'text-charcoal bg-bone border-bone-dark';
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-1056">
      <div className="flex justify-between items-start mb-4" data-id="element-1057">
        <div data-id="element-1058">
          <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-1059">{title}</p>
          <h3 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-1060">
            {value}
          </h3>
        </div>
        {icon && <div className={`p-2 rounded-lg ${getColorClass()}`} data-id="element-1061">{icon}</div>}
      </div>

      {(subtitle || trend !== undefined) && <div className="flex items-center gap-2 text-sm" data-id="element-1062">
          {trend !== undefined && <span className={`flex items-center font-medium ${trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-500'}`} data-id="element-1063">
              {trend > 0 ? <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-1064" /> : trend < 0 ? <ArrowDownRight className="w-3 h-3 mr-1" data-id="element-1065" /> : <Minus className="w-3 h-3 mr-1" data-id="element-1066" />}
              {Math.abs(trend)}%
            </span>}
          {subtitle && <span className="text-gray-400" data-id="element-1067">{subtitle}</span>}
        </div>}
    </motion.div>;
}